module.exports = __webpack_public_path__ + "static/media/estilosos_feminino_beleza.6578c19b.jpg";